import ArtDirectedImage from '@/components/Image/ArtDirectedImage';

import type { HighlightMediaTextProps } from './HighlightMediaTextFull';
import useStyles from './HighlightMediaTextFull.styles';
import InnerContent from './InnerContent';

const ImageFull = (props: HighlightMediaTextProps) => {
  const { isOnDark, imageAltText, imageSources, mobileImageAspectRatio } =
    props;
  const { cx, classes } = useStyles({ isOnDark, mobileImageAspectRatio });

  return (
    <div className={classes.relativeContainer}>
      {imageSources && (
        <ArtDirectedImage
          images={imageSources}
          alt={imageAltText || ''}
          role='presentation'
          className={classes.artDirectedImage}
        />
      )}
      <div className={cx(classes.innerContent, classes.imageInnerContent)}>
        <InnerContent {...props} />
      </div>
    </div>
  );
};

export default ImageFull;
